export default __webpack_public_path__ + "static/media/logo.1e76c524.png";